module.exports = __webpack_public_path__ + "img/zhiyebaike.5c2de24b.svg";